import { render, staticRenderFns } from "./RtbStatsRejectionByPublisher.vue?vue&type=template&id=05ba6eb8&scoped=true"
import script from "./RtbStatsRejectionByPublisher.vue?vue&type=script&lang=js"
export * from "./RtbStatsRejectionByPublisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba6eb8",
  null
  
)

export default component.exports